module.exports = __webpack_public_path__ + "pic/56.2c2e5928.png";